module.exports = __webpack_public_path__ + "static/media/binoculars.a755b9c2.svg";